import * as i0 from '@angular/core';
import { InjectionToken, PLATFORM_ID, ElementRef, Component, ChangeDetectionStrategy, Inject, Input, ViewChild, NgModule } from '@angular/core';
import { isPlatformBrowser, CommonModule } from '@angular/common';

const ADSENSE_TOKEN = new InjectionToken('AdsenseConfig');

class AdsenseComponent {
    constructor(config, 
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    platform) {
        this.config = config;
        this.platform = platform;
        /** can be manually set if you need all ads on a page to have same id page-xxx */
        this.adRegion = 'page-' + Math.floor(Math.random() * 10000) + 1;
        /**
         * classes applied to the ins element
         */
        this.className = '';
    }
    ngOnInit() {
        const config = this.config;
        this.adClient = this.adClient ?? config.adClient;
        this.adSlot = this.adSlot ?? config.adSlot;
        this.adFormat = this.adFormat ?? config.adFormat ?? 'auto';
        this.display = this.display ?? config.display ?? 'block';
        this.width = this.width ?? config.width;
        this.height = this.height ?? config.height;
        this.layout = this.layout ?? config.layout;
        this.layoutKey = this.layoutKey ?? config.layoutKey;
        this.pageLevelAds = this.pageLevelAds ?? config.pageLevelAds;
        this.adtest = this.adtest ?? config.adtest;
        this.fullWidthResponsive = this.fullWidthResponsive ?? config.fullWidthResponsive;
    }
    ngOnDestroy() {
        const iframe = this.ins.nativeElement.querySelector('iframe');
        if (iframe && iframe.contentWindow) {
            iframe.src = 'about:blank';
            iframe.remove();
        }
    }
    ngAfterViewInit() {
        if (isPlatformBrowser(this.platform)) {
            this.push();
        }
    }
    push() {
        const p = {};
        if (this.pageLevelAds) {
            p.google_ad_client = this.adClient;
            p.enable_page_level_ads = true;
        }
        if (window) {
            try {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (window.adsbygoogle = window.adsbygoogle || []).push(p);
            }
            catch {
                // pass
            }
        }
    }
}
AdsenseComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.0.0", ngImport: i0, type: AdsenseComponent, deps: [{ token: ADSENSE_TOKEN }, { token: PLATFORM_ID }], target: i0.ɵɵFactoryTarget.Component });
AdsenseComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.0.0", type: AdsenseComponent, selector: "ng2-adsense,ng-adsense", inputs: { adClient: "adClient", adSlot: "adSlot", adFormat: "adFormat", adRegion: "adRegion", display: "display", width: "width", height: "height", layout: "layout", layoutKey: "layoutKey", pageLevelAds: "pageLevelAds", adtest: "adtest", fullWidthResponsive: "fullWidthResponsive", className: "className" }, viewQueries: [{ propertyName: "ins", first: true, predicate: ["ins"], descendants: true, read: ElementRef, static: true }], ngImport: i0, template: `
    <ins
      #ins
      class="adsbygoogle {{ className }}"
      [style.display]="display"
      [style.width.px]="width"
      [style.height.px]="height"
      [attr.data-ad-client]="adClient"
      [attr.data-ad-slot]="adSlot"
      [attr.data-ad-format]="adFormat"
      [attr.data-ad-region]="adRegion"
      [attr.data-layout]="layout"
      [attr.data-adtest]="adtest"
      [attr.data-layout-key]="layoutKey"
      [attr.data-full-width-responsive]="fullWidthResponsive"
    >
    </ins>
  `, isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.0.0", ngImport: i0, type: AdsenseComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'ng2-adsense,ng-adsense',
                    template: `
    <ins
      #ins
      class="adsbygoogle {{ className }}"
      [style.display]="display"
      [style.width.px]="width"
      [style.height.px]="height"
      [attr.data-ad-client]="adClient"
      [attr.data-ad-slot]="adSlot"
      [attr.data-ad-format]="adFormat"
      [attr.data-ad-region]="adRegion"
      [attr.data-layout]="layout"
      [attr.data-adtest]="adtest"
      [attr.data-layout-key]="layoutKey"
      [attr.data-full-width-responsive]="fullWidthResponsive"
    >
    </ins>
  `,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [ADSENSE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [PLATFORM_ID]
                }] }]; }, propDecorators: { adClient: [{
                type: Input
            }], adSlot: [{
                type: Input
            }], adFormat: [{
                type: Input
            }], adRegion: [{
                type: Input
            }], display: [{
                type: Input
            }], width: [{
                type: Input
            }], height: [{
                type: Input
            }], layout: [{
                type: Input
            }], layoutKey: [{
                type: Input
            }], pageLevelAds: [{
                type: Input
            }], adtest: [{
                type: Input
            }], fullWidthResponsive: [{
                type: Input
            }], className: [{
                type: Input
            }], ins: [{
                type: ViewChild,
                args: ['ins', { read: ElementRef, static: true }]
            }] } });

class AdsenseModule {
    static forRoot(config = {}) {
        return {
            ngModule: AdsenseModule,
            providers: [{ provide: ADSENSE_TOKEN, useValue: config }],
        };
    }
}
AdsenseModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.0.0", ngImport: i0, type: AdsenseModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
AdsenseModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.0.0", ngImport: i0, type: AdsenseModule, declarations: [AdsenseComponent], imports: [CommonModule], exports: [AdsenseComponent] });
AdsenseModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.0.0", ngImport: i0, type: AdsenseModule, imports: [[CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.0.0", ngImport: i0, type: AdsenseModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    exports: [AdsenseComponent],
                    declarations: [AdsenseComponent],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { ADSENSE_TOKEN, AdsenseComponent, AdsenseModule };
//# sourceMappingURL=ng2-adsense.mjs.map
